<template>
  <div>
    <Nav />
    <h1>{{ webcams.name }} video</h1>
    <video
      id="video"
      width="568"
      height="320"
      controls
      :poster="
        'https://freecdn.belamionline.com/Data/Models/Model_' +
        webcams.id +
        '/ChatImage.jpg'
      "
      preload="none"
    >
      <source
        :src="
          'https://freecdn.belamionline.com/Data/Models/Model_' +
          webcams.id +
          '/ChatVideo.mp4'
        "
        type="video/mp4"
      />
      Your browser does not support the video tag.
    </video>

    <p style="text-align: center">
      <a
        :href="
          'https://www.friskyguys.com/models/bios/' +
          webcams.cam +
          '/about.php?mp_code=c9kvt'
        "
        class="link-review visit-belami"
        target="_blank"
        rel="nofollow"
        >Visit his chat room</a
      >
    </p>

    <Banners />

    <!-- <p style="text-align: center;">
      <a
        :href="'https://www.flirt4free.com/models/bios/'+ webcams.cam +'/about.php?mp_code=c9kvt'"
        class="link-review visit-belami"
        target="_blank"
        rel="nofollow"
      >Visit his chat room</a>
    </p> -->

    <Random />
  </div>
</template>

<script>
import webcams from "@/belcams.json";
import Random from "@/webcams/RandomBelCam";
import Banners from "@/views/Banners.vue";
import Nav from "@/views/BelamiNav.vue";
export default {
  props: ["id"],
  components: {
    Random,
    Nav,
    Banners,
  },
  metaInfo() {
    return {
      title: this.webcams.name + " Bel Ami model webcam chat video",
      meta: [
        {
          name: "description",
          content:
            "Video Of " +
            this.webcams.name +
            " - Bel Gay Porn Studio Model - Beautiful Web Cam Sex Chat Guys - Czech, Hungarian And Slovakian Boys",
        },
      ],
      link: [
        {
          rel: "canonical",
          href:
            "https://www.eastguys.net/tube/belami-cams/video/" +
            this.$route.params.id,
        },
      ],
    };
  },
  data() {
    return {
      webcams: [],
    };
  },

  methods: {
    getWebcams() {
      const webcamList = JSON.parse(JSON.stringify(webcams));
      const idNumber = parseInt(this.$route.params.id, 10);
      this.webcams = webcamList.find((x) => x.id === idNumber);
      // console.log(typeof idNumber);
      window.scrollTo(0, 0);
      // console.log(this.$route.name);
    },
    tracking() {
      this.$ga.page("/tube/belami-cams/video/" + this.$route.params.id);
    },
    reloadVid() {
      document.getElementById("video").load();
    },
  },
  created() {
    this.getWebcams();
    this.tracking();
  },
  watch: {
    $route() {
      this.getWebcams();
      this.reloadVid();
    },
  },
};
</script>